<article class="c-modal c-theme-consult-dialog t-primary">
    <h1 mat-dialog-title class="c-modal__title">
      Nuvem de palavras
    </h1>

  <section *ngIf="display" class="u-padding-horizontal u-padding-vertical-small c-theme-consult-dialog__main" >
    <red-wordcloud [wordcloud]="wordcloud"
                  [hideBody]="true"
                   [fixedTitle]="true"
    >
    </red-wordcloud>
  </section>

  <footer mat-dialog-actions class="c-modal__footer">
    <button mat-ripple
            class="c-button c-button--solid-reversed"
            [mat-dialog-close]="true">
      Voltar
    </button>

  </footer>
</article>
